<template>
  <div class="bodyBox2">
    <el-card class="box-card2">
      <div slot="header" class="clearfix">
        <div class="shooseListBox">
          <div class="chooseBox">
            <div style="color:#1A69CF">普查次数:</div>
            <div style="margin-left:15px">
              <el-select
                v-model="time"
                placeholder="请选择"
                size="mini"
                :popper-append-to-body="false"
              >
                <el-option label="第一次普查" value="1"></el-option>
                <el-option label="第二次普查" value="2"></el-option>
                <el-option label="第三次普查" value="3"></el-option>
                <el-option label="第四次普查" value="4"></el-option>
                <el-option label="第五次普查" value="5"></el-option>
              </el-select>
            </div>
          </div>
          <div class="chooseBox">
            <div style="color:#1A69CF">开始时间:</div>
            <div style="margin-left:15px">
              <el-date-picker
                v-model="stateYarn"
                value-format="yyyy"
                format="yyyy"
                type="year"
                placeholder="选择年"
                size="mini"
                :append-to-body="false"
              ></el-date-picker>
            </div>
          </div>
          <div class="chooseBox">
            <div style="color:#1A69CF">结束时间:</div>
            <div style="margin-left:15px">
              <el-date-picker
                value-format="yyyy"
                format="yyyy"
                v-model="endYarn"
                type="year"
                placeholder="选择年"
                size="mini"
                :append-to-body="false"
              ></el-date-picker>
            </div>
          </div>
          <div class="chooseBox">
            <div style="color:#1A69CF">数据类型:</div>
            <div style="margin-left:15px">
              <el-select
                v-model="type"
                placeholder="请选择"
                size="mini"
                :popper-append-to-body="false"
              >
                <el-option label="GDP" value="gdp"></el-option>
                <el-option label="人口" value="people"></el-option>
              </el-select>
            </div>
          </div>
          <div>
            <el-button type="primary" size="mini" @click="getTableData">查询</el-button>
          </div>
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%" height="600">
        <el-table-column :prop="item.pops" :label="item.name" v-for="item in  tableHeader"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      tableData: [],
      time: "1",
      stateYarn: "2020",
      endYarn: "2022",
      type: "gdp",
      tableHeader: []
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      console.log(this.stateYarn);
      let formData = new FormData();
      formData.append("time", this.time);
      formData.append("type", this.type);
      formData.append("startYear", this.stateYarn);
      formData.append("endYear", this.endYarn);
      //   formData.append("endTime", this.endyear);
      axios({
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `http://47.108.55.246:7090/NccDataService/getSSPDataInfo`,
        data: formData,
        method: "post"
      }).then(res => {
        let list = [];
        // console.log(res.data);
        Object.keys(res.data[0]).map(item => {
          //   console.log(item);
          if (item == "province") {
            list.push({ name: "省份", pops: item });
          } else {
            list.push({ name: item, pops: item });
          }
        });
        this.tableHeader = list.reverse();
        this.tableData = res.data;
        // hide();
        // console.log(res.data[0].datas);
        // console.log(res.data[0].datas);
        // console.log(JSON.parse(this.unzip(res.data[0].datas)));
      });
    }
  }
};
</script>

<style>
.bodyBox2 {
  width: 100%;
  height: 100%;
  padding: 10px;
}
.box-card2 {
  width: 100%;
}
.shooseListBox {
  width: 100%;
  height: 50px;
  /* background-color: aqua; */
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.chooseBox {
  display: flex;
  font-size: 13px;
  line-height: 50px;
}
</style>